// extracted by mini-css-extract-plugin
export default {"checkBoxGroupPageInfoBox":"CheckBoxGroupPage_checkBoxGroupPageInfoBox__-tKOU"};